import { render, staticRenderFns } from "./InventoriesContent.vue?vue&type=template&id=5b052870&scoped=true&"
import script from "./InventoriesContent.vue?vue&type=script&lang=js&"
export * from "./InventoriesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b052870",
  null
  
)

export default component.exports